import {useState, useEffect} from "react";
import {getAuth} from "firebase/auth";

const GnbTop = () => {
    const [users, setUsers] = useState(null);

    // const userInfo = {
    //     name: user.displayName,
    //     email: user.email,
    //     profile_image: user.photoURL,
    //     email_verified: user.emailVerified,
    //     uid: user.uid,
    // };

    useEffect(() => {
        const auth = getAuth();
        const user = auth.currentUser;
        setUsers(user);
    }, []);

    // const userName = users.map((user, idx) => (
    //     <li key={idx}>
    //         <p></p>
    //         <span>{user.displayName}님</span>
    //     </li>
    // ));
    return (
        <>
            <ul
                style={{
                    position: "absolute",
                }}
                className="gnb_top"
            >
                {/* {userName} */}
                <li>로그아웃</li>
            </ul>
        </>
    );
};
export default GnbTop;
